import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-leo-e1-policy",
  "use": "icon-leo-e1-policy-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-leo-e1-policy\">\r\n<g transform=\"translate(-70.400 -25.600) scale(1.120000)\">\r\n<path d=\"M512 96l352 128v256c0 224-144 384-352 448C320 864 176 704 176 480V224L512 96zm0 96L272 272v208c0 160 100 288 240 336 140-48 240-176 240-336V272L512 192z\" />\r\n  <path d=\"M448 448h128a48 48 0 0 1 48 48v160H400V496a48 48 0 0 1 48-48zm16 0v-48a48 48 0 0 1 96 0v48h-96zm32 96a40 40 0 0 0-16 76v52h32v-52a40 40 0 0 0-16-76z\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/leo-e1-policy.svg
// module id = BOlz
// module chunks = 396